var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Campaigns = MDB.DPN.Campaigns || {};

(function($){
    // var _apiUrl = '/api/DPN/Campaigns/Get';
    var _useTotalsTestData = false;
    var _useTimelineTestData = false;
    var _annotationsTimelineHideDelay = 2500;
    
    var _testDateDelay = 1000;
    var _colorGenerator;
    var _annotationCategoryColors = {
        'Default': '#CBCBCB',
        'Attention': '#DC0022',
        'Opmerking': '#3C5CF4',
        'Change': '#F66D1F',
        'Delivery': '#64B95E'
    };

    var _widgets = [];
    
    $.extend(MDB.DPN.Campaigns, {
        _loadCampaignTotalsWidgetTestDataSet: function(){
            function getRandomNumber(max, min){
                return Math.max(min || 0, Math.round(Math.random() * max));
            }
            
            return $.Deferred(function(def){
                var campaigns = getTestCampaigns();
                var dateRange = getDateRangeInDays();

                var data = _.map(dateRange, function(date) {
                    return _.reduce(campaigns, function(record, campaign){
                        record[campaign] = getRandomNumber(10000);
                        return record;
                    }, {date: date});
                });


                setTimeout(function(){
                    def.resolve(data);
                }, _testDateDelay);
            }).promise();
        },
        _loadCampaignTimelineWidgetTestDataSet: function(){
            function getRandomNumber(max, min){
                return Math.max(min || 0, Math.round(Math.random() * max));
            }

            return $.Deferred(function(def){
                var campaigns = getTestCampaigns();
                var dateRange = getDateRangeInDays();

                var data = _.map(campaigns, function(campaign){
                    var startDateIndex = getRandomNumber(dateRange.length - 2);
                    var endDateIndex = getRandomNumber(dateRange.length - 1, startDateIndex + 1);

                    return {
                        name: campaign,
                        startDate: dateRange[startDateIndex],
                        endDate: dateRange[endDateIndex],
                        id: MDB.guid()
                    }
                });


                setTimeout(function(){
                    def.resolve(data);
                }, _testDateDelay);
            }).promise();
        },
        _loadAnnotationTimelineWidgetTestDataSet: function(){
            function getRandomNumber(max, min){
                return Math.max(min || 0, Math.round(Math.random() * max));
            }
            
            return $.Deferred(function(def){
                var range = getDateRangeInDays();
                
                //Take all but default
                var categories = _.reject(Object.keys(_annotationCategoryColors), function(k){return k === 'Default'});
                
                var data = _.map(range, function(date){
                    if(!Math.round(Math.random() - 0.2)){
                        return undefined;
                    }
                    
                    var category = categories[getRandomNumber(categories.length - 1)];
                    
                    return {
                        date: date,
                        description: 'Description of ' + category + ' event',
                        category: category
                    }
                });

                def.resolve(_.filter(data));
            });
        },
        _loadCampaignTotalsWidgetRemoteDataSet: function(opts){
            return $.Deferred(function(def){
                //TODO: Gather data as regular widget?
                $.ajax({
                    url: opts.url + '?' + $.param(getApiFilters())
                }).done(function(rawResults){
                    //Keeping track of two seperate sets should be the way to go
                    //One for the result records grouped by day
                    //One for the actual result array
                    var resultsPerDay = {};
                    var results = [];

                    //Target data format:
                    //[
                    //   { date: '2019-01-01', Campaign_Name_1: Total_1, Campaign_Name_2: Total_2  },
                    //   { date: '2019-01-01', Campaign_Name_1: Total_1, Campaign_Name_2: Total_2 }
                    //]
                    
                    //Raw result data format:
                    //[
                    //  { Date: '2019-01-01', Campaign: Campaign_Name_1, Total: 5 }
                    //  { Date: '2019-01-02', Campaign: Campaign_Name_1, Total: 8 }
                    //  { Date: '2019-01-01', Campaign: Campaign_Name_2, Total: 6 }
                    //  { Date: '2019-01-02', Campaign: Campaign_Name_2, Total: 1 }
                    //]
                    
                    rawResults.forEach(function(rawResult){
                        var result = resultsPerDay[rawResult.Date];
                        if(!result){
                            result = resultsPerDay[rawResult.Date] = {};
                            result.date = new Date(rawResult.Date);
                            results.push(result);
                        }
                        
                        result[rawResult.Campaign] = rawResult.Total;
                    });

                    def.resolve(results);
                });
            }).promise();
        },
        _loadCampaignTimelineDurationWidgetRemoteDataSet: function(opts){
            return $.Deferred(function(def){
                //TODO: Gather data as regular widget?
                $.ajax({
                    url: opts.url + '?' + $.param(getApiFilters())
                }).done(function(result){
                    //Map results to common format, ignoring results that can't be displayed due to being incomplete
                    result = _.reduce(result, function(mapped, item){
                        mapped = mapped || [];
                        
                        //Ignore any data that can't be displayed
                        if(item.EndDate && item.StartDate && item.Name){
                            mapped.push({
                                id: item.Id,
                                name: item.Name,
                                startDate: moment(item.StartDate).toDate(),
                                endDate: moment(item.EndDate).toDate()
                            })
                        }
                        
                        return mapped;
                    }, []);
                    
                    def.resolve(result);
                });
            }).promise();
        },
        _loadAnnotationTimelineWidgetRemoteDataSet: function(opts){
            return $.Deferred(function(def){
                $.ajax({
                    url: opts.url + opts.id
                }).done(function(result){
                    //Map to common format
                    result = result.map(function(item){
                        return {
                            date: moment(item.Date).toDate(),
                            description: item.Description,
                            category: item.Type,
                            channels: item.CampaignChannelsValue,
                            titles: item.CampaignTitlesValue,
                            creator: item.CreatedByValue
                        }
                    });

                    def.resolve(result);
                });
            }).promise();
        },
        _loadCampaignTotalsWidgetDataSet: function(opts){
            var impl = MDB.DPN.Campaigns._loadCampaignTotalsWidgetRemoteDataSet;
            if(_useTotalsTestData === true){
                impl = MDB.DPN.Campaigns._loadCampaignTotalsWidgetTestDataSet;
            }
            
            return impl(opts);
        },
        _loadCampaignTimelineWidgetDataset: function(opts){
            var impl = MDB.DPN.Campaigns._loadCampaignTimelineDurationWidgetRemoteDataSet;
            if(_useTimelineTestData === true){
                impl = MDB.DPN.Campaigns._loadCampaignTimelineWidgetTestDataSet;
            }
            
            return impl(opts);
        },
        _loadAnnotationTimelineWidgetDataSet: function(opts){
            var impl = MDB.DPN.Campaigns._loadAnnotationTimelineWidgetRemoteDataSet;
            if(_useTimelineTestData === true){
                impl = function(){
                    return MDB.DPN.Campaigns._loadAnnotationTimelineWidgetTestDataSet();
                };
            }

            return impl(opts);
        },
        getDefaultDateRange: function () {
            return {
                //Start of last month
                startDate: moment().add(-1, 'month').startOf('month').toDate(),
        
                //End of next month
                endDate: moment().add(1, 'month').endOf('month').toDate()
            };
        },
       initCampaignTimelineWidget: function(selector, opts){
           opts = opts || {};
           var kendoConfig = opts.kendoConfig || {};
            
           selector = $(selector);
           
           var container = $('<div />', {class: 'rangebar-widget-container'});
           var labelContainer = $('<div />', {class: 'rangebar-widget-label-container'});
           
           labelContainer.appendTo(selector);
           container.appendTo(selector);
           
           return MDB.DPN.Campaigns._loadCampaignTimelineWidgetDataset(opts).done(function(data){
               var dateRange = getDateRangeInDays(opts);
               
               data.filter(function(d){ return d.startDate.getTime() === d.endDate.getTime(); }).forEach(function(d){
                   //Kendo only draws the label when start/end are equal
                   //For a better looking gauge; ensure startDate is just a tiny bit earlier than the endDate in such cases
                   d.startDate = moment(d.startDate).add(-1, 'second').toDate();
               });
               
               //Total milliseconds per month varies, and kendo does not support a 'month' major unit
               //Use weeks as a compromise
               var majorUnit = 7 * 24 * 60 * 60 * 1000; //One week

               var min = dateRange[0].getTime();
               var max = dateRange[dateRange.length - 1 ].getTime();
               
               var customHoverHandlers = {};
               
               //https://docs.telerik.com/kendo-ui/controls/charts/how-to/various/timeline-using-range-bars
               var chartKendoConfig = {
                   chartArea: {
                       height: 350
                   },
                   dataSource: {
                       //Category needs to be something unique, otherwise kendo will flip out
                       group: 'id',
                       data: data
                   },
                   valueAxis: {
                       min: min,
                       max: max,
                       majorUnit: majorUnit,
                       labels: {
                           template: '#= moment(new Date(value)).isoWeek() #',
                           visible: false,
                           position: 'top',
                           align: 'top',
                           rotation: 90
                       }
                   },
                   series: [{
                       type: 'rangeBar',
                       fromField: 'startDate',
                       toField: 'endDate',
                       labels: {
                           visible: true,
                           template:  '#= dataItem.name #',
                           background: 'transparent',
                           position: 'center'
                       },
                       color: function(args){
                           return getColorFor(args.dataItem.name);
                       }
                   }],
                   legend: {
                       visible: false
                   },
                   seriesHover: function(e){
                       //Only trigger if we've got a custom event handler
                       if(!opts.getSeriesLabelHoverBody){
                           return;
                       }
                       
                       //Once we've attached our own eventhandlers, we can ignore kendo
                       if(customHoverHandlers[e.dataItem.uid] && !e._isCustom) 
                       {
                           return;
                       }
                       
                       var seriesColor = '#FFFFFF'; //e.series.color.apply(this, arguments);

                       var linkContainer = container.find('.chart-link-container');
                       linkContainer.remove();

                       linkContainer = $('<div />', {'class': 'chart-link-container'});

                       //Every drawn bar consists of a g element with an transform attribute (the actual bar)
                       //Followed by 2 g elements with opacity attributes (the displayed text)
                       var targetNodeSelector = e.element.is('text') ? e.element : e.element.closest('[opacity]').find('text');
                       if(!targetNodeSelector.length){
                           var topLevelNode = e.element.is('[transform]') ? e.element : e.element.closest('[transform]');
                           targetNodeSelector = topLevelNode.next().find('text');
                       }
                       
                       var barNode = targetNodeSelector.closest('[opacity]').prev();
                       if(!barNode.is('[transform]')){
                           barNode = barNode.prev();
                       }

                       //Kendo retains its selected/hover state even after an element no longer has focus via mouseover
                       //By default, kendo marks an element as out of focus as soon as another element gains focus/the mouse leaves the chart
                       //To prevent our this from hindering us, attach our own event handlers to the series bar + labels
                       if(!customHoverHandlers[e.dataItem.uid]){
                           customHoverHandlers[e.dataItem.uid] = true;

                           var thisArg = this;
                           var args = arguments;
                           var fn = args.callee;
                           
                           e._isCustom = true;
                           
                           barNode.on('mouseover', function(){ fn.apply(thisArg, args); });
                           barNode.next().on('mouseover', function(){ fn.apply(thisArg, args); });
                           barNode.next().next().on('mouseover', function(){ fn.apply(thisArg, args); });
                           
                           barNode.on('mouseleave', function(){
                               //Ensure event also works after initial hover
                               var currentLinkContainer =  container.find('.chart-link-container');
                              
                               if(!currentLinkContainer.is(':hover')){
                                   currentLinkContainer.remove();
                               }
                           });
                       }
                       
                       var targetNode = targetNodeSelector[0];

                       var targetNodeBoundingRect = targetNode.getBoundingClientRect();
                       var containerNodeBoundingRect = container[0].getBoundingClientRect();

                       var containerTop = containerNodeBoundingRect.top + window.pageYOffset;

                       linkContainer.append(opts.getSeriesLabelHoverBody(e));
                       linkContainer.prependTo(container);
                       
                       //Ensure no half/quarter pixels are leftover
                       //this can cause a slight bit of the original bar to peek through at the bottom
                       var top = Math.floor((targetNodeBoundingRect.top + window.pageYOffset) - containerTop) + 1;
                       var linkContainerWidth = linkContainer.width();
                       
                       var left = (targetNodeBoundingRect.left - containerNodeBoundingRect.left) - (linkContainerWidth / 4);

                       //Should not exceed containers bounds
                       left = Math.min(left, containerNodeBoundingRect.width - linkContainerWidth);
                       left = Math.max(left, 0);
                       
                       linkContainer.css({
                           'background-color': seriesColor,
                           'top': top,
                           'left': left
                       });
                       
                       linkContainer.on('mouseleave', function(){
                           if(!barNode.is(':hover')){
                               linkContainer.remove();
                           }
                       });
                   },
                   seriesClick: function(e){
                       var dataItem = e.dataItem
                           , value = e.value;
                       
                       //Remove previous items
                       container.find('.marker-timeline-chart').remove();
                       
                       //Some nodes nested in the actual bar aren't regarded as visible but are still clickable
                       var targetNode = e.element[0];
                       if(targetNode.getBoundingClientRect().top === 0){
                           targetNode = targetNode.parentNode;
                       }
                       
                       var targetNodeBoundingRect = targetNode.getBoundingClientRect(); 
                       var containerNodeBoundingRect = container[0].getBoundingClientRect();
                       
                       var containerTop = containerNodeBoundingRect.top + window.pageYOffset;
                       var top = targetNodeBoundingRect.height + (targetNodeBoundingRect.top + window.pageYOffset) - containerTop;
                       
                       var targetNodeRelativeX = targetNodeBoundingRect.left - containerNodeBoundingRect.left;
                       
                       var el = $('<div />', {'class': 'marker-timeline-chart horizontal-timeline-chart'});
                       
                       el.prependTo(container);
                       
                       var timelineWidth = el.width();
                       var timelineLeft = el.position().left;

                       //Width, left, etc... can only be calculated once the element is actually present in the dom
                       //Width has to be halved as we want to center the element
                       var left = (targetNodeRelativeX + (targetNodeBoundingRect.width / 2)) - ((timelineWidth / 2) + timelineLeft);
                       
                       //Timeline should never horizontally go out of bounds of its container
                       left = Math.min(left, containerNodeBoundingRect.width - (timelineWidth + timelineLeft));
                       left = Math.max(left, 0);
                       
                       el.css({
                           // 'width': container.width() - elementWidthOffset,
                           // 'margin-left': elementWidthOffset / 2,
                           'top': top,
                           'left': left
                       });
                       
                       MDB.DPN.Campaigns.initAnnotationTimelineWidget(el, { 
                           url: opts.annotationUrl,
                           id: dataItem.id,
                           startDate: value.from,
                           endDate: value.to
                       });

                       setTimeout(function hideElementWhenOutOfFocus(){
                           if(!el.is(':hover')){
                               el.fadeOut(500);
                           }
                           else{
                               setTimeout(hideElementWhenOutOfFocus, _annotationsTimelineHideDelay);
                           }
                       }, _annotationsTimelineHideDelay);
                   }
               };
               
               var labelKendoConfig = {
                   chartArea: {
                       height: 50
                   },
                   dataSource: {
                       data: []
                   },
                   series: [{ type: 'rangeBar' }],
                   categoryAxis: {
                       line: {
                           visible: false
                       },
                       majorGridLines: {
                           visible: false,
                       },
                       minorGridLines: {
                           visible: false
                       },
                   },
                   valueAxis: {
                       line: {
                           visible: false,
                       },
                       majorGridLines: {
                           visible: false,
                       },
                       minorGridLines: {
                           visible: false
                       },
                       min: min,
                       max: max,
                       majorUnit: majorUnit,
                       labels: {
                           template: '#= moment(new Date(value)).format("W") #',
                           visible: true,
                           // position: 'top',
                           // rotation: 45
                       }
                   },
                   legend: {
                       visible: false
                   }
               };

               chartKendoConfig = $.extend(true, chartKendoConfig, kendoConfig);
               labelKendoConfig = $.extend(true, labelKendoConfig, kendoConfig);
               
               _widgets.push(labelContainer.kendoChart(labelKendoConfig));
               _widgets.push(container.kendoChart(chartKendoConfig));
           });
       }, 
       initCampaignTotalsWidget: function(selector, opts){
            opts = opts || {};
           var kendoConfig = opts.kendoConfig || {};
           selector = $(selector);

           var container = $('<div />', {class: 'area-widget'});
           container.appendTo(selector);
           
           //Data format:
           //[
           //   { date: '2019-01-01', Campaign_Name_1: Total_1, Campaign_Name_2: Total_2  },
           //   { date: '2019-01-01', Campaign_Name_1: Total_1, Campaign_Name_2: Total_2 }
           //]
           
           return MDB.DPN.Campaigns._loadCampaignTotalsWidgetDataSet(opts).done(function(data){
               var keyMappings = MDB.Charts.transformKeysToKendoFields(data);

               var chartKendoConfig = {
                   chartArea: { 
                       height: 350 
                   },
                   dataSource: { 
                       data: data 
                   },
                   categoryAxis: {
                       field: 'date',
                       type: 'date',
                       labels: {
                           visible: false
                       }
                   },
                   seriesDefaults: {
                       type: "column",
                       stack: true
                   },
                   valueAxis: {
                       reverse: true,
                       type: 'numeric',
                       labels: {
                           visible: false
                       }
                   },
                   tooltip: {
                       visible: true,
                       font: "12px Arial,Helvetica,sans-serif",
                        template: MDB.Charts.combineWithDefaultTooltipTemplate('#= value # (#= moment(dataItem.date).format("DD-MM") #)'),
                       border: {
                           width: 1
                       }
                   },
                   series: _.map(keyMappings.slice(1), function(keyMapping){
                       return {
                           field: keyMapping.field,
                           name: keyMapping.originalKey,
                           color: getColorFor(keyMapping.originalKey)
                       }
                   }),
                   legend: {
                       visible: false
                   }
               };

               chartKendoConfig = $.extend(chartKendoConfig, kendoConfig);

               _widgets.push(container.kendoChart(chartKendoConfig));
           });
       }, 
        initAnnotationTimelineWidget: function(selector, opts){
            var loadWidgetDataProm = MDB.DPN.Campaigns._loadAnnotationTimelineWidgetDataSet(opts);
            
            var infoContainer = $('<div />', {'class': 'timeline-annotation-info'}).hide();
            
            var body = $('<div />', {'class': 'timeline-body'})
                .append($('<div />', {'class': 'timeline-line'}));
            
            var timeline = $('<div />').css({'width': '100%', 'height': 60})
                .append($('<div />', {'class': 'timeline-arrow timeline-arrow-left fas fa-2x fa-angle-left'}))
                .append(body)
                .append($('<i />', {'class': 'timeline-arrow timeline-arrow-right fas fa-2x fa-angle-right'}));
            
            infoContainer.prependTo(selector);
            timeline.prependTo(selector);
            
            loadWidgetDataProm.done(function(annotations){
                if(!annotations.length){
                    return;
                }
                
                var sortedAnnotations = _.sortBy(annotations, 'date');

                //We are guaranteed to have notifications, and we are guaranteed to have them sorted by date
                //Hence we can just take the first one to determine the first notification date
                var firstAnnotationDate = moment(sortedAnnotations[0].date);
                var start = moment(opts.startDate);
                
                //When the first annotation was made before the start of the campaign, take that date as our start value
                if(start > firstAnnotationDate){
                    start = firstAnnotationDate;
                }

                //Partition the available width of the element over the total amount of days 
                var totalWidth = body.width() * 0.85; //Width defined as 85% in stylesheet
                var totalDays = moment(opts.endDate).diff(start, 'day');

                //When our campaign spans a single day, we can just take the complete width of the bar
                var pixelsPerDay = totalDays !== 0 ? totalWidth / totalDays : totalWidth;
                
                var previousPosition;

                sortedAnnotations.forEach(function(annotation){
                    var date = moment(annotation.date)
                        , daysAfterStart = date.diff(start, 'day');
                    
                    //Ensure annotation are not drawn on top of eachother by forcing a minimum width between them
                    var position = Math.round(daysAfterStart * pixelsPerDay);
                    if(position <= previousPosition){
                        position = previousPosition + 8;
                    }
                    previousPosition = position;
                    
                    var annotationElement = $('<i />', { 'class': 'timeline-item fas fa-2x fa-map-marker-alt' })
                        .css({
                            'color': getAnnotationColor(annotation.category),
                            'left': position
                        });
                    
                    annotationElement.data('annotation', annotation);
                    
                    body.prepend(annotationElement);
                });

                var isEntering = false;

                body.find('.timeline-item').on('mouseenter', function(){
                    isEntering = true;

                    var annotation = $(this).data('annotation');
                    infoContainer.html(getAnnotationInfoHtml(annotation));
                    infoContainer.show();

                    isEntering = false;
                }).on('mouseout', function(){
                    if(!isEntering){
                        infoContainer.hide();
                    }
                });
            });
        },
        getWidgets: function () {
          return _widgets;
        },
        getDateRange: function () {
            var defaults = MDB.DPN.Campaigns.getDefaultDateRange();
    
            var startDate = defaults.startDate;
            var endDate = defaults.endDate;
    
            //Only if an actual range has been specified, override defaults
            if(MDB.Charts) {
                if(MDB.Charts.dateStart){
                    startDate = moment(MDB.Charts.dateStart, MDB.Charts.dateFilterFormat).toDate();
                }
    
                if(MDB.Charts.dateEnd){
                    endDate = moment(MDB.Charts.dateEnd, MDB.Charts.dateFilterFormat).toDate();
                }
            }
    
            return {
                startDate: startDate,
                endDate: endDate
            }
        }
    });

    function getColorGenerator(){
        return MDB.Charts.createColorGenerator();
    }

    function getColorFor(str){
        if(!_colorGenerator){
            _colorGenerator = getColorGenerator();
        }

        return _colorGenerator(str);
    }
    
    function getAnnotationInfoHtml(annotation){
        var rowTemplate = '<div class="row">' +
                '<div class="col-5"><span class="annotation-field-label">%s:</span></div>' +
                '<div class="col-7"><span data-bind="%s"></span></div>' +
            '</div>';
        
        var template =
            '<div class="row">' +
                '<div class="col-7">' +
                    sprintf(rowTemplate, MDB.loadResourceString('Dpn_CampaignAnnotationModel_Date_DisplayName'), 'date') +
                    sprintf(rowTemplate, MDB.loadResourceString('Dpn_CampaignAnnotationModel_Category_DisplayName'), 'category') +
                    sprintf(rowTemplate, MDB.loadResourceString('Dpn_CampaignAnnotationModel_CreatedBy_DisplayName'), 'creator') +
                    sprintf(rowTemplate, MDB.loadResourceString('Dpn_CampaignAnnotationModel_CampaignChannels_DisplayName'), 'channels') +
                    sprintf(rowTemplate, MDB.loadResourceString('Dpn_CampaignAnnotationModel_CampaignTitles_DisplayName'), 'titles') +
                '</div>' +
                '<div class="col-5">' +
                    '<span class="d-inline-block annotation-field" style="padding-left: 5px; padding-right: 5px;" data-bind="description"></span>' +
                '</div>' +
            '</div>';

        template = $(template);
        template.find('[data-bind="date"]').text(moment(annotation.date).format('DD-MM-YYYY'));
        template.find('[data-bind="description"]').text(annotation.description);
        template.find('[data-bind="creator"]').text(annotation.creator);
        template.find('[data-bind="channels"]').text(annotation.channels);
        template.find('[data-bind="titles"]').text(annotation.titles);
        template.find('[data-bind="category"]')
            .text(annotation.category)
            .css({'color': getAnnotationColor(annotation.category)});


        return $('<div />').append(template).html();
    }
    
    function getAnnotationColor(annotationCategory){
        return _annotationCategoryColors[annotationCategory] || _annotationCategoryColors['Default'];
    }
    
    function getDateRange(){
        return MDB.DPN.Campaigns.getDateRange();
    }
    
    function getApiFilters(){
        var dateRange = getDateRange();
        
        return {
            startDate: moment(dateRange.startDate).format(MDB.Charts.dateFilterFormat),
            endDate: moment(dateRange.endDate).format(MDB.Charts.dateFilterFormat),
            serializedFilters: JSON.stringify(MDB.Charts.getArraySerializedFilters())
        };
    }
    
    function getDateRangeInDays(){
        var now = moment()
            , dateRange = getDateRange();
        
        //from start of last month to end of next month
        var start = moment(dateRange.startDate).diff(now, 'day');
        var end = moment(dateRange.endDate).diff(now, 'day') + 1;
        
        return _.map(_.range(start, end, 1), function(day){
            return moment().add(day, 'day').toDate();
        });
    }

    function getTestCampaigns(){
        return ['SOA', 'LGBT', 'Happy Cactus', 'Krantenmens'];
    }
})(jQuery);
